import React from "react";

/* eslint-disable react/prop-types */

export const ScreenContext = React.createContext({
  screenMode: false,
  //#!if iOS === true
// isEditMode: false,
// enterEditMode: null,
// exitEditMode: null
  //#!endif
});

export function withScreenContext(Component) {
  /* eslint-disable react/display-name */
  class ScreenComponent extends React.Component {
    render() {
      const { forwardedRef, ...rest } = this.props;

      return (
        <ScreenContext.Consumer>
          {screenContext => {
            return <Component ref={forwardedRef} {...rest} screenContext={screenContext} />;
          }}
        </ScreenContext.Consumer>
      );
    }
  }

  return React.forwardRef((props, ref) => {
    return <ScreenComponent {...props} forwardedRef={ref} />;
  });
}
